import type { ErrorCatalog } from '@hc-frontend/core-context';

export const applicationErrors: ErrorCatalog = {
  location: {
    actions: {
      failedToFetchLocationByIp: 'Failed to fetch location by IP',
      failedToGetLocationByZip: 'Failed to get location by ZIP',
      failedToGetUSALocation: 'Failed to get USA location',
    },
  },
  leadSession: {
    actions: {
      failedToSaveVisit: 'Failed to save user visit',
      failedToGetProspect: 'Failed to get prospect',
      failedToGetSessionIdentifiers: 'Failed to get session id',
      failedToParseCookies: 'Failed to parse cookies',
      failedToParseDomainFromUrl: 'Failed to parse domain from URL',
      failedToGetIsOepFromStateAcronym:
        'Failed to get is OEP from state acronym',
      failedToParseLeadSessionFromUrl: 'Failed to parse lead session from URL',
      failedToLoadLeadSessionIdentifier:
        'Failed to load lead session identifier',
      failedToGetPlacement: 'Failed to get placement',
      failedToCreateProspect: 'Failed to create prospect',
      failedToUpdateProspect: 'Failed to update prospect',
      failedToUpdateLeadProduct: 'Failed to update lead product',
      failedToGetLocationByZip: 'Failed to get location by zip',
      failedToUpdateProspectJourney: 'Failed to update prospect journey',
      failedToUpdateProspectProductType:
        'Failed to update prospect product type',
      failedToHandleContextualTraffic: 'Failed to handle contextual traffic',
      failedToUpdateProspectLandingUrl: 'Failed to update prospect landing url',
      failedToUpdateProspectAnalyticsIdentifier:
        'Failed to update prospect analytics identifier',
      failedToUpdateProspectLocation: 'Failed to update prospect location',
      failedToGetLead: 'Failed to get lead',
      failedToUpdateProspectCoverageUrgency:
        'Failed to update prospect coverage urgency',
      failedToTransformCoverageUrgency: 'Failed to transform coverage urgency',
      failedToUpdateProspectEnrolledPartAPartB:
        'Failed to update prospect enrolled part A part B',
      failedToUpdateProspectGenderDateOfBirth:
        'Failed to update prospect gender and date of birth',
      failedToCleanProspectGenderDateOfBirth:
        'Failed to clean prospect gender and date of birth',
      failedToUpdatePersonalInformation:
        'Failed to update personal information',
      failedToTransformGenderDateOfBirth:
        'Failed to transform gender and date of birth',
      failedToTransformEnrolledPartAPartB:
        'Failed to transform enrolled part A part B',
      failedToTransformPersonalInformation:
        'Failed to transform personal information',
      failedToGetAnswers: 'Failed to get answers',
      failedToGetProduct: 'Failed to get the product',
      failedToUpdateProspectCoverageDuration:
        'Failed to update prospect coverage duration',
      failedToTransformCoverageDuration:
        'Failed to transform coverage duration',
      failedToTransformImmediateCoverage:
        'Failed to transform immediate coverage',
      failedToUpdateProspectImmediateCoverage:
        'Failed to update prospect immediate coverage',
      failedToTransformSeniorCheck: 'Failed to transform senior check',
      failedToUpdateProspectSeniorCheck:
        'Failed to update prospect senior check',
      failedToUpdateProspectEstimatedSpending:
        'Failed to update prospect estimated spending',
      failedToTransformEstimatedSpending:
        'Failed to transform estimated spending',
      failedToUpdateProspectInsureWho: 'Failed to update prospect insure who',
      failedToTransformInsureWho: 'Failed to transform insure who',
      failedToUpdateProspectSpouseChildren:
        'Failed to update prospect spouse children',
      failedToTransformSpouseChildren: 'Failed to transform spouse children',
      failedToTransformQualifyingLifeEvent:
        'Failed to transform qualifying life event',
      failedToUpdateProspectQualifyingLifeEvent:
        'Failed to update prospect qualifying life event',
      failedToGetIncomeFromFpl: 'Failed to get income from FPL',
      failedToUpdateProspectLeadId: 'Failed to update prospect lead id',
      failedToMoveToStartPlate: 'Failed to move to start plate',
    },
  },
  marketing: {
    actions: {
      failedToSendContactToMarketing: 'Failed to send contact to marketing',
    },
  },
  core: {
    unexpectedException: 'Something went wrong',
    unhandledOperationError: 'Something went wrong',
    unknownException: 'Something went wrong',
    tryAgain: 'Try again',
  },
  tracking: {
    actions: {
      sessionCouldNotBeLoaded: 'The session could not be loaded',
      sessionNotInitializedYet: 'The session is not initialized yet',
      failToGetDomainSessionId: 'Failed to get domain session id',
      failedToGetDomainUserId: 'Failed to get domain user id',
      failedToTrackSubmitZipPlate: 'Failed to track ZIP-plate submit',
      failedToTrackSubmitPersonalInformationPlate:
        'Failed to track Personal-information-plate submit',
    },
  },
  products: {
    actions: {
      failedToFetchUserOrders: 'Failed to fetch user orders',
      failedToFetchRecommendedProducts: 'Failed to fetch recommended products',
      minimumRecommendedProductsNotFulfilled:
        'Minimum recommended products not fulfilled',
    },
  },
  quotes: {
    actions: {
      failedToFetchMetalLevels: 'Failed to retrieve metal levels',
      failedToFetchPlanTypes: 'Failed to retrieve plan types',
      failedToFetchCarriers: 'Failed to retrieve carriers',
      failedToFetchCarriersById: 'Failed to retrieve carriers by id',
      failedToFetchPlanQuotes: 'failedToFetchPlanQuotes',
      failedToFetchPlanDetails: 'failedToFetchPlanDetails',
    },
  },
  session: {
    actions: {
      failedToCreateHealthcareSession: 'Failed to create healthcare session',
      failedToReadHealthcareSessionId: 'Failed to read healthcare session id',
      failedToReadHealthcareUserId: 'Failed to read healthcare user id',
      failedToReadSessionDataFromUrl: 'Failed to read session data from URL',
      failedToReadUserTrackingParameters:
        'Failed to read user tracking parameters',
      failedToUpdateHealthcareSession: 'Failed to update healthcare session',
      failedToWriteHealthcareSessionIds:
        'Failed to write healthcare session ids',
      failedToPersistHealthcareSession: 'Failed to persist healthcare session',
      failedToGetHealthcareSession: 'Failed to get healthcare session',
      failedToGetHealthcareSessionIdentifier:
        'Failed to get healthcare session identifier',
      failToGetTrackingParameters: 'Failed to get tracking parameters',
      failToGetLandingUrl: 'Failed to get landing URL',
      failToGetSrcListFromCdn: 'Failed to get SRC List',
    },
  },
  featuredAds: {
    actions: {
      failedToFetchFeaturedAds: 'Failed to fetch featured ads',
      failedToTrackClick: 'Failed to track ad click',
      failedToTrackConversion: 'Failed to track ad conversion',
      failedToTrackImpression: 'Failed to track ads impression',
      failedToCreateHealthcareSession: 'Failed to create healthcare session',
      failToGetAdsAllowlistConfigFromCdn:
        'Failed to get ads allowlist configuration from cdn',
    },
  },
  survey: {
    actions: {
      failedToSubmitPlate: 'Failed to submit plate',
      failedToGetJourney: 'Failed to get journey',
      failedToSaveAction: 'Failed to save action',
      failedToGetNextPlate: 'Failed to get next plate',
      failedToMoveToPlate: 'Failed to move to plate',
      failedToAuditLead: 'Failed to audit lead',
      failedToExtractSurveyAnswers: 'Failed to extract survey answers',
      failedToGetJourneyProgress: 'Failed to get journey progress',
      failedToGetCurrentPlate: 'Failed to get current plate',
      failedToSaveAndTryAgain: 'Failed to save, please try again',
    },
  },
  journey: {
    actions: {
      failedToGetPageIdentifier: 'Failed to get the page identifier',
    },
  },
  auction: {
    actions: {
      failedToFetchBuyers: 'Failed to fetch buyers',
      failedToSendToDestination: 'Failed to send to destination',
      failedToParseAuctionParameters: 'Failed to parse auction parameters',
      failedToParseBuyer: 'Failed to parse buyer',
      failedToFetchPriceDiscovery: 'Failed to fetch price discovery',
      failedToParseAuctionConsentParameters:
        'Failed to parse auction consent parameters',
      failedToFetchPartnerConfiguration:
        'Failed to fetch partner configuration',
      failedToParseGetPartnerConfigurationsParameters:
        'Failed to parse get partner configurations parameters',
      failedToParseSearchPartnerTcpaParameters:
        'Failed to parse search partner tcpa parameters',
      failedToSearchPartnerTcpa: 'Failed to search partner tcpa',
    },
  },
};
